import { motion } from 'framer-motion';
import styled from 'styled-components';

import { styledReset } from '@pkg/primitives';

export const Hamburger = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    position: absolute;
    top: 30px;
    right: 30px;
    z-index: 3;

    width: 26px;
    height: 26px;
    gap: 5px;

    cursor: pointer;
`;

export const Line = styled(motion.div)`
    width: 30px;
    height: 4px;
    background-color: white;
    border-radius: 5px;
`;

export const Menu = styled(motion.div)`
    position: fixed;
    top: 0;
    right: 0;
    z-index: 2;

    width: 100%;
    height: 100%;
    height: 100dvh;

    background-color: #090719;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

export const LoginButton = styled.button`
    ${styledReset.button}

    color: #fff;
    font-size: 24px;
    line-height: 120%;
    font-weight: 700;
    letter-spacing: 0em;

    margin-bottom: 20px;
`;
